import css from 'styled-jsx/css'

import { sizes } from '../../../theme'


export default css`
.container {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

aside {
  display: flex;
  width: 96rem;
}

.cover aside {
  width: 120rem;
}

.container :global(.thumbs) {
  display: flex;
  flex: 2;
  flex-direction: column;
}

.container :global(.cover-image) {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  position: relative;
}

.container :global(.image.gatsby-image-wrapper) {
  max-width: 120rem;
  max-height: 62rem;
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .container {
    display: block;
    height: auto;
  }

  aside {
    display: block;
    width: 100%;
  }

  .cover aside {
    width: 100%;
  }

  .container :global(.cover-image) {
    width: 100%;
    margin: 0 auto;
  }

  .container :global(.thumbs) {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .container :global(.thumb) {

  }

  .container :global(.thumb img) {
    width: 100%;
  }
}
`
